/**
 * Borrower — the two inputs that reach the sheet's credit rows.
 *
 * Its own card, the way the RTL sizer gives the entity and the applicants their
 * own: these are attributes of a PERSON, not of the loan or the collateral, and
 * a card edge says that far more plainly than a rule inside a longer sheet.
 */
import {
  Section,
  Grid,
  Field2,
  NumInput,
  SelectInput,
} from "../../sizersShared/sizerUi";
import { CITIZENSHIPS } from "../dscrConstants";
import GateError from "./GateError";

export default function BorrowerSection({ form, set, gate }) {
  // The sheet prices a Foreign National off its own row, without a score — so
  // the FICO gate lifts on that selection rather than blocking a real scenario.
  const isForeignNational = String(form.citizenshipStatus || "")
    .toLowerCase()
    .includes("foreign national");

  return (
    <Section
      first
      title="Borrower"
      subtitle="Credit and citizenship pick the LLPA bucket the price is built from."
    >
      <Grid cols={2}>
        {/* Gated by the FICO x LTV LLPA grid — the sheet prices no default
            bucket, so a missing score is a 422, not a silent assumption. */}
        <Field2 label="FICO" required={!isForeignNational}>
          <NumInput
            value={form.resolvedCreditScore}
            onChange={(v) => set("resolvedCreditScore", v)}
            placeholder={isForeignNational ? "Not required" : "740"}
          />
          <GateError fields={gate} name="resolvedCreditScore" />
        </Field2>
        <Field2
          label="Citizenship status"
          tip="Foreign National prices off the sheet's own FN row — no credit score needed."
        >
          <SelectInput
            value={form.citizenshipStatus ?? ""}
            onChange={(v) => set("citizenshipStatus", v)}
            options={CITIZENSHIPS}
          />
        </Field2>
      </Grid>
    </Section>
  );
}
